import React from 'react';
import { Button } from 'rebass';
import { FiXCircle } from 'react-icons/fi';

import config from 'config';
import { useToastHelper } from 'hooks/useToastHelper';
import { useDeleteStudyIntegrationMutation } from 'api/useDeleteStudyIntegrationMutation';

/**
 * Displays a linked Dscout study with the ability to unlink it.
 *
 * @param {Object} props
 * @param {Object} props.integration - The Dscout integration object
 * @param {number} props.studyId - The study ID (needed for the delete API call)
 * @param {Function} props.onDelete - Callback fired after successful deletion
 */
function DscoutIntegration({ integration, studyId, onDelete }) {
    const { addSuccessToast } = useToastHelper();

    const { mutate: deleteIntegration } = useDeleteStudyIntegrationMutation({
        onSuccess: () => {
            addSuccessToast('Dscout study unlinked successfully');
            onDelete?.();
        }
    });

    const handleDelete = e => {
        e.stopPropagation();
        if (!confirm('Are you sure you want to unlink this Dscout study?')) {
            return;
        }
        deleteIntegration({ studyId, integrationId: integration.id });
    };

    const missionName = integration?.metadata?.name;
    const projectName = integration?.metadata?.projectName;

    if (!missionName) {
        return null;
    }

    return (
        <div className="border rounded-12 show-on-hover-container relative ml-3">
            <a
                href={config.DSCOUT_APP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center border-clickable cursor-pointer no-underline py-2 px-5"
            >
                <img src={`${config.UI_SUFFIX}/dscout.png`} style={{ width: '26px' }} alt="Dscout" />
                <div className="shrink-0 ml-4" style={{ maxWidth: '250px' }}>
                    <div className="text-secondary-dark fs-12 ellipsis">{projectName || 'Unknown project'}</div>
                    <div className="medium text-primary ellipsis mt-1">{missionName}</div>
                </div>
            </a>
            <Button
                variant="link"
                className="show-on-hover-element link-small red absolute"
                style={{ top: '-8px', right: '-8px' }}
                onClick={handleDelete}
            >
                <FiXCircle className="circle" style={{ fontSize: '16px' }} />
            </Button>
        </div>
    );
}

export default DscoutIntegration;
